import React, { Component } from 'react';
import TopupForm from './TopupForm';
import BuxService from '../../../Service/BuxService';
import TransactionService from '../../../Service/TransactionService';
import AccountService from '../../../Service/AccountService';
import { LogError } from '../../../AppUtil/AppUtil';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			channelData: {}
		};
	}

	componentDidMount() {
		this.getChannelCodes();
	}
	getChannelCodes = async () => {
		this.toggleLoader();
		try {
			const response = await AccountService.getBuxChannelCodes();

			if (!response) {
				throw new Error('Get channel codes failed');
			}
			this.setState({
				channelData: response,
				_isLoading: false
			});
		} catch (err) {
			this.toggleLoader();

			LogError(err);
		}
	};

	toggleLoader = () => {
		this.setState({
			_isLoading: !this.state._isLoading
		});
	};

	toastFail = msg => {
		Swal.fire({
			customClass: 'otp_message_success',
			allowOutsideClick: false,
			animation: false,
			title: 'Error',
			allowOutsideClick: false,
			text: msg,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: 'Try again'
		});
	};

	toaster = msg => {
		Swal.fire({
			title: 'Info',
			allowOutsideClick: false,
			text: msg,
			icon: 'info',
			confirmButtonText: 'OK',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				window.location.href = '/profile';
			}
		});
	};

	onTopupDetailsSubmit = async topupData => {
		try {
			this.toggleLoader();
		
			let newData = topupData;
			Object.keys(topupData).forEach(key => {
				if (typeof topupData[key] != 'string') newData[key] = topupData[key].toString();
			});

			const response = await BuxService.buxWalletTopup(newData);
			if (!response || response.status === 'failed') {
				const msg = response.message || 'Top up request failed';
				this.toastFail(msg);
				throw new Error(msg);
			}

			window.open(response.payload.link);
			this.toaster(this.props.t('sweetalert.top_up_info'));
			this.props.toHome();
			this.toggleLoader();

			// RECORD TOPUP DATA AS HISTORY
			await TransactionService.create({
				...topupData,
				reference_number: response.payload.ref_code
			});
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	render() {
		return (
			<TopupForm
				channelData={this.state.channelData}
				closeProfileScreen={this.props.closeProfileScreen}
				currentUser={this.props.currentUser.profile}
				isLoading={this.state._isLoading}
				onSubmit={this.onTopupDetailsSubmit}
				user={this.props.user}
			/>
		);
	}
}

export default withStyles(commonStyleForEditPersonalInfo)(withTranslation()(index));
